import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import type { Rental } from '../lib/rental';
import RentalCard from './RentalCard';

export default function LazyRentalCard({rental, priority}: { rental: Rental, priority?: boolean }) {
  const [root, setRoot] = useState<Element | null>(null);

  useEffect(() => {
    // On mobile, the window itself scrolls. On desktop (md:), the specific div scrolls.
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const updateRoot = () => {
      setRoot(mediaQuery.matches ? document.getElementById('rental-scroll-container') : null);
    };
    
    updateRoot();
    mediaQuery.addEventListener('change', updateRoot);
    return () => mediaQuery.removeEventListener('change', updateRoot);
  }, []);

  const { ref, inView } = useInView({ 
    triggerOnce: true, 
    rootMargin: '1200px', // Aggressively prefetch images well before they scroll into view
    root: root
  });
  
  const shouldRender = inView || priority;

  return (
    <div ref={ref} className="h-full flex items-stretch">
      {shouldRender ? (
        <RentalCard rental={rental} />
      ) : (
        <div className="rounded-xl bg-gray-100 h-[360px] animate-pulse" />
      )}
    </div>
  );
}
